<template>
  <div class="flex border text-gray-900">
    <div class="w-1/2 border-r border-gray-200">
      <CompanyStatusDropdown />
    </div>
    <div class="w-1/2">
      <CompanyManagerDropdown />
    </div>
  </div>
</template>

<script>
import CompanyStatusDropdown from "./CompanyStatusDropdown";
import CompanyManagerDropdown from "./CompanyManagerDropdown";

export default {
  components: {
    CompanyStatusDropdown,
    CompanyManagerDropdown
  }
};
</script>